const moment = require('moment-timezone');

angular
  .module('ordersWait')
  .component('ordersWait', {
    template: require('./orders-wait.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function _($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.showOrderView = $rootScope.gShowOrderView;

        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'orderWait';
        this.targetDate = moment().format('YYYY-MM-DD');
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        $scope.paging = (page) => {
          $resource(`${APIURL}/admin/reservation/waits`).get({ targetDate: this.targetDate, page, timezone: moment.tz.guess() }, (data) => {
            console.log(data);
            this.waits = data.waits;
            this.waitsCount = data.waits.length;
            this.matchedCount = data.waits.filter(wait => wait.STATUS.toString() === '1').length;
            this.washCount = data.waits.filter(wait => wait.STATUS.toString() === '1' && !wait.ORDER_CANCELLED).length;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.showSwitchModal = (wait) => {
          this.targetWait = wait;
          this.targetWait.payload = { HOUR: '10', MINUTE: '00', timezone: moment.tz.guess() };
          jQuery('#modal-switch').modal('show');
        };

        this.completeSwitch = () => {
          $resource(`${APIURL}/admin/reservation/waits/${this.targetWait.ORDER_NO}`).save(this.targetWait.payload, () => {
            alert($translate.instant('수정되었습니다.'));
            jQuery('#modal-switch').removeClass('fade');
            jQuery('#modal-switch').modal('hide');
            $window.location.reload();
            this.paging(1);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.onDatePick = () => {
          this.targetDate = jQuery('#inputPicker').val();
          $scope.paging(1);
        };

        this.movePrevDate = () => {
          const prevMoment = moment(this.targetDate, 'YYYY-MM-DD').add(-1, 'days');
          this.targetDate = prevMoment.format('YYYY-MM-DD');
          $scope.paging(1);
        };
        this.moveNextDate = () => {
          const prevMoment = moment(this.targetDate, 'YYYY-MM-DD').add(1, 'days');
          this.targetDate = prevMoment.format('YYYY-MM-DD');
          $scope.paging(1);
        };

        $resource(`${APIURL}/admin/employees`).get({ count: 10000, include_unregister: false }, (data) => {
          this.employees = data.users;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        this.total_count = 0;
        $scope.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/orders-wait/orders-wait.component.js